import { Chip as ChipCore } from '@material-ui/core';
import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const Chip = lib.styled(ChipCore)`
  background-color: ${colors.darkGray12} !important;

  .MuiChip-label {
    padding-left: 10px;
    padding-right: 6px;
    color: ${colors.white};
  }
`;
